module.exports = __webpack_public_path__ + "static/media/HomeCover.a3d1fab9.jpg";